<template>
  <div>
    <div id="membership">
      <div class="topText">
        <h1>2024 Season Memberships</h1>
        <div class="line"></div>
        <p>
          For next season, you have the <strong>option to choose</strong> which
          Season Membership package best suits your needs:
          <strong
            >A Traditional Season Membership or a Flexible Season
            Membership.</strong
          >
          Both options feature great benefits of being a Rays Season Member.
        </p>

        <h2>Traditional Season Membership</h2>
        <p>
          With a Traditional Season Membership, you will have the option to
          choose the ticket plan and specific seat location that best fits your
          needs. We are excited to bring back not only Full Season Plans, but
          also Half Season Plans (Weekend and Weekday) along with three 22 Game
          Plans (Friday, Saturday and Sunday Plans).
        </p>

        <div class="renewBtn yellow">
          <b-button v-scroll-to="{ el: '#Traditional', offset: -10 }"
            >TRADITIONAL SEASON MEMBERSHIP INFORMATION</b-button
          >
        </div>
        <h2>Flexible Season Membership</h2>
        <p>
          With a Flexible Season Membership, you continue to receive the
          benefits of our most important stakeholders, while ensuring the
          flexibility to choose your games and seats throughout the 2024 regular
          season. Whether it's seats for two in the AeroVanti Club or tickets for you
          and five friends in the Outfield, your seat location and quantity are
          up to you. A Flexible Season Membership ensures your priority as a
          Rays Season Member and provides early access to tickets for your
          choice of games.
        </p>
        <p class="small">
          <span>Flexibility</span> Redeem your membership credit for as many
          games as you want to attend, one at a time or all at once. Use the
          credit on your account to buy any combination of tickets, up to six
          per game.
        </p>
        <p class="small">
          <span>Value</span>Enjoy Season Member benefits and discounted ticket
          pricing with savings over single-game tickets.
        </p>
        <p class="small">
          <span>Priority Access to Tickets</span> A Flexible Season Membership
          ensures your priority as a Rays Season Member and provides access to
          tickets ahead of the general public.
        </p>
        <div class="renewBtn yellow">
          <b-button v-scroll-to="{ el: '#Flexible', offset: -50 }"
            >FLEXIBLE SEASON MEMBERSHIP INFORMATION</b-button
          >
        </div>
      </div>
    </div>
    <Banner bannerDivider="first" />
  </div>
</template>

<script>
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "Flex",
  components: {
    Banner,
  },
};
</script>

<style lang="scss" scoped>
#membership {
  text-align: center;
  margin: auto;
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/welcome/bgImage_gray.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .topText {
    width: 700px;
    margin: auto;
    @media only screen and (max-width: $lg) {
      width: 80%;
    }
    .line {
      background-color: $yellow;
      width: 492px;
      height: 5px;
      margin: 15px auto 1em;
      @media only screen and (max-width: $sm) {
        width: 80%;
      }
    }
    h1 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 35px;
      line-height: 1;
      text-transform: uppercase;
      color: #00285e;

      @media only screen and (max-width: $sm) {
        font-size: 25px;
      }
    }
    h2 {
      font-family: "Antique Olive";
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 31px;
      text-transform: uppercase;
      color: #00285e;
      margin-block: 100px 30px;
      @media only screen and (max-width: $md) {
        margin-block: 50px;
      }
    }
    p {
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 145%;
      text-align: center;
      color: #161e26;
      &.small {
        width: 500px;
        @media only screen and (max-width: $sm) {
          width: auto;
        }
        margin-inline: auto;
        padding-inline: 10px;
      }
      span {
        display: block;
        /* body big caps */

        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        text-transform: uppercase;
        color: #00285e;
        margin-top: 30px;
      }
      &.topLine {
        text-align: center;
      }
    }

    .renewBtn {
      text-align: center;
      margin-top: 10px;
      &.yellow button {
        background: #ffd200;
        border: none;
        padding: 14px 40px;
      }
      button {
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 145%;
        display: flex;
        align-items: center;
        text-align: center;
        text-transform: uppercase;
        color: #00285e;
        width: auto;
        margin-inline: auto;
        border: 2px solid #00285e;
        border-radius: 50px;
        padding: 10px 40px;
        margin-top: 50px;
        background: transparent;
        &:hover {
          text-decoration: none;
        }
        @media only screen and (max-width: $sm) {
          padding: 8px 4px;
        }
      }
    }
  }

  .smallPrint {
    font-family: "UniversLTStd-Obl";
    text-align: left;
    font-size: 14px;
    margin-top: 30px;
  }
}
</style>


